import { bootstrapApplication } from '@angular/platform-browser';
import { Auth } from '@aws-amplify/auth';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

// Configure Amplify Auth with Cognito before bootstrapping the app
Auth.configure(environment.cognito);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
